<template>
    <div class="more-actions">
        <sections 
            :titles="sectionNames"
            @changeSection="index => activeSection = index"
        >
            <reset-password 
                v-if="activeSection == 0"
                :webshopID="webshopID"
                @done="dt => this.$emit('done', dt)"
            />
            <limits 
                v-if="activeSection == 1"
                :webshopID="webshopID"
            />
            <game-type-restrictions 
                v-if="activeSection == 2"
                :webshopID="webshopID"
            />
        </sections>
    </div>
</template>

<script>
import Sections from '@/components/ReusableComponents/Sections/Sections.vue'
import ResetPassword from './ResetPassword.vue'
import Limits from './Limits.vue'
import GameTypeRestrictions from './GameTypeRestrictions.vue'
export default {
    components: {
        Sections, ResetPassword, Limits, GameTypeRestrictions
    },
    props: {
        webshopID: Number,
    },
    data() {
        return {
            activeSection: 0,
        }
    },
    computed: {
        sectionNames() {
            var sections = [
                this.$t('WEBSHOPS__RESET_PASSWORD'),
                this.$t('WEBSHOPS__LIMITS'),
            ]
            if(this.isSupervisor) {
                sections.push(this.$t('WEBSHOPS__GAME_TYPES'))
            }
            return sections
        },
        isSupervisor() {
            return this.$store.state.shop
        }
    },
}
</script>

<style lang="scss" scoped>
h4 {
    text-align: center;
    font-size: 18 * $rem;
    font-weight: 500;
    display: block;
    margin-bottom: 30 * $rem;
}

form {
    display: flex;

    label {
        margin-right: 15 * $rem;
    }
}
</style>